import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { useCurrentCompany } from './useCurrentCompany';

export interface CompanySubscription {
  id: string;
  name: string;
  price: number;
  subscription_type: string;
  access_type: string;
  access_value: number;
  contract_term: string;
  billing_cycle: string;
  created_at: string;
  prepayment_required: boolean;
  prepayment_months: number;
  is_free_trial: boolean;
  requires_approval: boolean;
  allows_cash_payment: boolean;
  trial_duration_days: number | null;
  trial_duration_classes: number | null;
  trial_duration_period: string | null;
}

export function useCompanySubscriptions() {
  const { data: companyId } = useCurrentCompany();

  return useQuery({
    queryKey: ['company-subscriptions', companyId],
    enabled: !!companyId,
    queryFn: async (): Promise<CompanySubscription[]> => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .from('company_subscriptions')
        .select('id, name, price, subscription_type, access_type, access_value, contract_term, billing_cycle, created_at, prepayment_required, prepayment_months, is_free_trial, requires_approval, allows_cash_payment, trial_duration_days, trial_duration_classes, trial_duration_period')
        .eq('company_id', companyId)
        .eq('is_deleted', false)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return (data ?? []) as CompanySubscription[];
    },
    staleTime: 60 * 1000,
  });
}
